document.addEventListener("DOMContentLoaded", () => {
  // Función para abrir el modal
  const openModal = (modal) => {
    if (modal) {
      modal.style.display = "block";
      document.body.style.overflow = "hidden";
    }
  };

  // Función para cerrar el modal
  const closeModal = (modal) => {
    if (modal) {
      modal.style.display = "none";
      document.body.style.overflow = "";
    }
  };

  // Obtener elementos
  const botonCotizarEnvio = document.querySelector(".inicio_boton-cotizar-envio");
  const cotizarEnvioEscritorio = document.getElementById("cotizarEnvioEscritorio");
  const cotizarEnvioMovil = document.getElementById("cotizarEnvioMovil");
  const modalEnvio = document.getElementById("modalEnvio");
  const botonCerrarModal = document.querySelector(".cerrar-modal");

  // Agregar eventos solo si los elementos existen
  if (botonCotizarEnvio) {
    botonCotizarEnvio.addEventListener("click", () => openModal(modalEnvio));
  }

  if (cotizarEnvioEscritorio) {
    cotizarEnvioEscritorio.addEventListener("click", () => openModal(modalEnvio));
  }

  if (cotizarEnvioMovil) {
    cotizarEnvioMovil.addEventListener("click", () => openModal(modalEnvio));
  }

  if (botonCerrarModal) {
    botonCerrarModal.addEventListener("click", () => closeModal(modalEnvio));
  }

  // Cerrar el modal al hacer clic fuera de él
  if (modalEnvio) {
    window.addEventListener("click", (event) => {
      if (event.target === modalEnvio) {
        closeModal(modalEnvio);
      }
    });
  }
});
